import { create } from "zustand";

const usePermissionStore = create((set) => ({
  admins: [] as StudentLicenseInfo[],
  setAdmins: (admins: StudentLicenseInfo[]) => set(() => ({ admins: admins })),
  updateAdmins: (admin: StudentLicenseInfo) => set((state) => ({ admins: [admin, ...state.admins] })),
  urlAfterActivatingAdmin: "",
  setUrlAfterActivatingAdmin: (url: string) => set(() => ({ urlAfterActivatingAdmin: url })),
}));

export default usePermissionStore;
